export default __webpack_public_path__ + "static/media/ContactUs.c36ad8c6.svg";